export const CHAT_CHANNEL_NAME = 'ChatChannel'

export const CHAT_CHANNEL = (starId = null) => ({
  channel: CHAT_CHANNEL_NAME,
  star_id: starId,
})
